import { Link } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { Card, CardContent } from '@/components/ui/card'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table'
import { LoadingSpinner } from '@/components/common/LoadingSpinner'
import { ErrorMessage } from '@/components/common/ErrorMessage'
import { AlertBadge } from '@/components/alert/AlertBadge'
import { useAlerts } from '@/hooks/useAlerts'
import { Plus } from 'lucide-react'

export const AlertListPage = () => {
  const { data, isLoading, error } = useAlerts()

  if (error) {
    return <ErrorMessage message="Failed to load alerts. Please try again." />
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-3xl font-bold">Alert Configurations</h1>
        <Button asChild>
          <Link to="/alerts/new">
            <Plus className="mr-2 h-4 w-4" />
            New Alert
          </Link>
        </Button>
      </div>

      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <Card>
          <CardContent className="p-0">
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>Name</TableHead>
                  <TableHead>Device Type</TableHead>
                  <TableHead>Condition</TableHead>
                  <TableHead>Severity</TableHead>
                  <TableHead>Devices</TableHead>
                  <TableHead>Recipients</TableHead>
                  <TableHead>Status</TableHead>
                  <TableHead className="text-right">Actions</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {data?.alerts && data.alerts.length > 0 ? (
                  data.alerts.map((alert) => (
                    <TableRow key={alert.id}>
                      <TableCell className="font-medium">{alert.alertName}</TableCell>
                      <TableCell>{alert.deviceType || 'All'}</TableCell>
                      <TableCell className="text-sm">
                        {alert.paramLabel || alert.measurementColumn} {alert.comparisonOperator}{' '}
                        {alert.thresholdValue} {alert.unit}
                      </TableCell>
                      <TableCell>
                        <AlertBadge severity={alert.severityLevel} />
                      </TableCell>
                      <TableCell>{alert.deviceCount}</TableCell>
                      <TableCell>{alert.recipientCount}</TableCell>
                      <TableCell>
                        {alert.isActive ? (
                          <span className="text-green-600">Active</span>
                        ) : (
                          <span className="text-gray-400">Inactive</span>
                        )}
                      </TableCell>
                      <TableCell className="text-right">
                        <Button variant="outline" size="sm" asChild>
                          <Link to={`/alerts/${alert.id}/edit`}>Edit</Link>
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={8} className="text-center py-8 text-muted-foreground">
                      No alerts configured
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </CardContent>
        </Card>
      )}
    </div>
  )
}
